import {
  SUBSCRIBE_SUCCESS,
  SUBSCRIBE_FAIL,
  UNSUBSCRIBE_SUCCESS,
  UNSUBSCRIBE_FAIL,
  UPDATE_POLL_LAST_CHANGED_TIME_SUCCESS,
  UPDATE_POLL_LAST_CHANGED_TIME_FAIL
} from './actions';

const initialState = {
  polls: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBSCRIBE_SUCCESS:
      return {
        ...state,
        polls: [...state.polls, action.data]
      };
    case UNSUBSCRIBE_SUCCESS:
    case UPDATE_POLL_LAST_CHANGED_TIME_SUCCESS:
      return {
        ...state,
        polls: action.data
      };
    case SUBSCRIBE_FAIL:
    case UNSUBSCRIBE_FAIL:
    case UPDATE_POLL_LAST_CHANGED_TIME_FAIL:
      console.log('action:', action);
      return state;
    default:
      return state;
  }
};

export default reducer;
